// src/Footer.js
import React from 'react';

const Footer = () => (
  <footer className="footer">
    SolarQuotePro<sup style={{ fontSize: '8px', opacity: 0.5, verticalAlign: 'super' }}>TM</sup>
    {' '}by Takoussane Energy — v1.0.1 — © {new Date().getFullYear()}
  </footer>
);

export default Footer;
